import Button from "../../../custom/button/button";
import { ReactComponent as Add } from "../../../assets/Plus Math.svg";
import { ReactComponent as Delete } from "../../../assets/deleteIcon.svg";
import { ReactComponent as View } from "../../../assets/view.svg";
import { ReactComponent as Print } from "../../../assets/Print.svg";
import { ReactComponent as DownloadPdf } from "../../../assets/Export Pdf.svg";
import { ReactComponent as Cancel } from "../../../assets/cancel.svg";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "../dashboardPage.module.scss";
import { App, Modal, Spin, Table } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createUpdateWorkHistory,
  deleteWorkHistory,
  getWorkHistoryByApplicantId,
} from "../../../utils/request";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import { formatDate } from "../../../utils/formatDate";
import { limitString } from "../../../utils/limitString";
import { ColumnsType } from "antd/es/table";
import WorkHistoryForm from "../../../components/onboardingSteps/workHistory/form";

const WorkHistory = () => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const user = useAtomValue(userAtom);
  const queryClient = useQueryClient();

  const { notification } = App.useApp();

  const { data, isLoading } = useQuery({
    queryKey: ["get-work-history"],
    queryFn: () => getWorkHistoryByApplicantId(user?.applicantId ?? ''),
  });

  const workHistoryData = data?.data ?? [];

  const createUpdateWorkHistoryMutation = useMutation({
    mutationFn: createUpdateWorkHistory,
  });

  const deleteWorkHistoryMutation = useMutation({
    mutationFn: deleteWorkHistory,
  });

  const handleCreateUpdateWorkHistory = async (values: WorkHistory) => {
    const formData = new FormData();

    formData.append("Id", "0");
    formData.append("ApplicantId", user?.applicantId ?? '');
    formData.append("CompanyName", values.company);
    formData.append("Position", values.position);
    formData.append("IsCurrentJob", String(values.currentJob));
    formData.append("StartDate", values.startDate);
    formData.append("EndDate", values.endDate);
    if (values.upload) {
      formData.append("Emplyment", values.upload);
    }

    try {
      await createUpdateWorkHistoryMutation.mutateAsync(formData, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          setShowModal(false);
          queryClient.refetchQueries({ queryKey: ["get-work-history"] });
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const handleDeleteWorkHistory = async (id: number) => {
    try {
      await deleteWorkHistoryMutation.mutateAsync(id, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          setShowModal(false);
          queryClient.refetchQueries({ queryKey: ["get-work-history"] });
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const column: ColumnsType<WorkHistoryData> = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Company",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
    },
    {
      title: "Evidence of Employment",
      dataIndex: "employmentUrl",
      key: "employmentUrl",
      render: (text: string) => <span>{limitString(text)}</span>,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (text: string) => <span>{formatDate(text)}</span>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (text: string) => <span>{formatDate(text)}</span>,
    },
    {
      title: "Action",
      dataIndex: "TransDate",
      key: "TransDate",
      render: (_, record) => (
        <span>
          {
            <>
              <View
                onClick={() => {
                  navigate(`/view-work-history/${record?.id}`);
                }}
                style={{ marginInlineEnd: "1rem" }}
              />

              <Delete onClick={() => handleDeleteWorkHistory(record?.id)} />
            </>
          }
        </span>
      ),
    },
  ];

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <>
      <PageLayout
        heading="Work History"
        headerActions={
          <>
            <Button
              onClick={() => {
                setShowModal(true);
              }}
              iconBefore={<Add />}
              text="Add"
            />
            {/* <Button
              iconBefore={<DownloadPdf />}
              text="Download"
              bgColor="#CE9938"
            /> */}
          </>
        }
      >
        {/* <div className={styles.rectangle}>
          <span>Filter</span>
          <FilterSelect
            placeholder="Category"
            // options={categoryOptions}
            // value={category}
            // onChange={handleSelectCategory}
          ></FilterSelect>
        </div> */}
        <Table
          columns={column}
          dataSource={workHistoryData}
          className={styles.row}
          rowKey={"DueYear"}
          scroll={{ x: 400 }}
          //   pagination={{ current: currentPage, pageSize: pageSize, onChange: handlePaginationChange, position: ["bottomCenter"] }}
          pagination={false}
        />
      </PageLayout>
      <Modal
        open={showModal}
        footer=""
        onCancel={() => setShowModal(false)}
        centered
        closeIcon={<Cancel />}
        className="modal"
        width={900}
      >
        <div className={styles.modalContent}>
          <div>
            <p>Work History</p>
            <p>All fields marked with a (*) are required.</p>
          </div>

          <hr />

          <br />
          <WorkHistoryForm
            workHistory={[]}
            editIndex={null}
            isLoading={createUpdateWorkHistoryMutation?.isPending}
            buttonText="Create"
            onSubmit={handleCreateUpdateWorkHistory}
          />
        </div>
      </Modal>
    </>
  );
};

export default WorkHistory;
